import http from "../utils/http";

/**************子食堂管理****************/

/**
 *  子食堂-分页列表
 */
export function getSubCanteenList(params) {
  return http({
    method: 'get',
    url: '/system/xcwsSubEntity/paging',
    params
  });
}

/**
 *  子食堂-添加
 */
export function addSubCanteen(data) {
  return http({
    method: 'post',
    url: '/system/xcwsSubEntity/add',
    data
  });
}

/**
 *  子食堂-编辑
 */
export function editSubCanteen(data) {
  return http({
    method: 'post',
    url: '/system/xcwsSubEntity/update',
    data
  });
}

/**
 *  子食堂-详情
 */
export function getSubCanteenDetail(params) {
  return http({
    method: 'get',
    url: '/system/xcwsSubEntity/find',
    params
  });
}

/**
 *  子食堂-启用禁用
 */
export function enableSubCanteen(available, data) {
  return http({
    method: 'post',
    url: '/system/xcwsSubEntity/opt/' + available,
    data
  });
}

/**
 *  子食堂-删除
 */
export function delSubCanteen(data) {
  return http({
    method: 'post',
    url: '/system/xcwsSubEntity/delete',
    params: data
  });
}

/**************子食堂模块配置****************/

/**
 *  模块配置-查看
 */
export function findModule() {
  return http({
    method: 'post',
    url: '/system/xcwsSubEntityConf/find'
  });
}

/**
 *  模块配置-修改
 */
export function updateModule(data) {
  return http({
    method: 'post',
    url: '/system/xcwsSubEntityConf/update',
    data
  });
}
